import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=8205d150&"
import script from "./CheckComponent.vue?vue&type=script&lang=js&"
export * from "./CheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckComponent.vue?vue&type=style&index=0&id=8205d150&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports